// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-quote.js';

import { paths } from '../generated/text-quote';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-quote', Original, paths);
